import { Field, TextInput, TextArea, SectionCard } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditSeo({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="SEO & Compartilhamento">
      <div className="space-y-5">
        <Field label="Título da aba (browser)"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="seo-title-input" /></Field>
        <Field label="Meta description (Google e compartilhamento)">
          <TextArea value={value.description} onChange={(v) => set("description", v)} rows={3} testId="seo-description-input" />
        </Field>
        <Field label="Palavras-chave (separadas por vírgula)"><TextInput value={value.keywords} onChange={(v) => set("keywords", v)} testId="seo-keywords-input" /></Field>
        <ImageUploadField
          label="Imagem de compartilhamento (Open Graph)"
          value={value.ogImage}
          onChange={(v) => set("ogImage", v)}
          testId="seo-og-image"
        />
      </div>
    </SectionCard>
  );
}
